import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [zones, setZones] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [grupoIncentivos, setGrupoIncentivos] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listSupervisor() {
    let response = await wsFindBy('sale/portafolio-bureau-supervisor', {base_zone_id: dataChanging.base_zone_id, base_business_partner_id: 10});
    if (response.success) setSupervisors(response.data);
  }
  async function listGrupoIncentivo() {
    let response = await wsGetAll('sale/softy-grupo');
    if (response.success) setGrupoIncentivos(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            base_zone_code: item.ZONAL,
            code: item.SUPERVISOR,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.base_zone_id) {
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: bPartnerSelect?.base_zone_id || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listZones();listGrupoIncentivo();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if (dataChanging.base_zone_id) {
      setDataChanging(prev => ({
        ...prev,
        base_supervisor_id: null,
      }));
      setSupervisors([]);
      listSupervisor();
    }
  }, [dataChanging.base_zone_id]);

  return (
    <>
      <Modal
        title={`Nueva cuota de supervisor`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.base_zone_id
            ? 'sale/softy-supervisor'
            : 'sale/softy-supervisor/multiple'
        }
        dataForce={
          dataChanging.base_zone_id
            ? {
              base_zone_id: dataChanging.base_zone_id,
              base_supervisor_id: dataChanging.base_supervisor_id,
              }
            : {
                base_zone_id: cuota.valueSearch?.base_zone_id,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(item) => `${item.description} (Código: ${item.code})`}
            renderInput={(params) => (
              <TextField {...params} label="Zonas" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('base_zone_id', item?.id); setDataImport(null);}}
            value={zones.find((zone) => zone.id === dataChanging.base_zone_id) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['SUPERVISOR','ZONAL','CUOTA']}
            sortDuplicate="CUOTA"
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.periodo).format('YYYY-MM')}_Plantilla de cuota para supervisor`,
              fields: ['ZONAL','MESA','GRUPO','SUPERVISOR','CUOTA']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.base_zone_id ? (
          <>
            <Autocomplete
              disableClearable
              options={supervisors}
              getOptionLabel={(item) => `${item.name})`}
              renderInput={(params) => (
                <TextField {...params} label="supervisor" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_supervisor_id', item?.base_supervisor_id); setDataImport(null);}}
              value={supervisors.find((supervisor) => supervisor.base_supervisor_id === dataChanging.base_supervisor_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
              disabled={!supervisors.length}
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
